import { Injectable, Type, inject, InjectFlags } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SingletonInjectorGuard {
    constructor(type: Type<any>) {
      const parent = inject(type, InjectFlags.Optional | InjectFlags.SkipSelf);
    }
  }
